import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          event = event.clone({
            headers: event.headers
              .set('Cache-Control', 'no-cache, no-store, must-revalidate')
              .set('Pragma', 'no-cache')
              .set('Expires', '0')
          });
        }
      })
    );
  }
}
